import axios from 'axios';

class ServerApi {

  prefix = '/_api/crm-inbox-server/chat';

  _fetch(options) {
    options.headers = Object.assign({}, options.headers, {
      'X-SV-TOKEN': this.sessionToken,
      'X-WIX-INSTANCE': this.instance
    });
    return axios(options).then(response => response.data);
  }

  setSessionToken(sessionToken) {
    this.sessionToken = sessionToken;
  }

  getSessionToken() {
    return this.sessionToken;
  }

  setInstance(instance) {
    this.instance = instance;
  }

  setVisibilityOff(instance) {
    return this._fetch({
      method: 'put',
      url: `${this.prefix}/settings`,
      headers: {
        'X-Wix-Chat-Instance': instance,
      },
      data: {
        chatVisible: false
      }
    });
  }

  getSettings() {
    return this._fetch({
      method: 'get',
      url: `${this.prefix}/settings-public`
    });
  }

  sendMessage(message, clientReferenceId) {
    return this._fetch({
      method: 'post',
      url: `${this.prefix}/message`,
      data: {
        message,
        clientReferenceId
      }
    });
  }

  init(queryParams = {}) {
    return this._fetch({
      method: 'post',
      url: `${this.prefix}/init`,
      params: queryParams
    });
  }
}

export default new ServerApi();



// WEBPACK FOOTER //
// ./chat-app/services/serverApi.js